var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "row" }, [
    _c("div", { staticClass: "col-3" }, [
      _vm._m(0),
      _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.point_reward,
            expression: "point_reward",
          },
        ],
        ref: "point_reward",
        staticClass: "form-control",
        attrs: {
          min: "0",
          max: "1000000",
          type: "number",
          disabled: !_vm.canEdit,
        },
        domProps: { value: _vm.point_reward },
        on: {
          change: _vm.update,
          input: function ($event) {
            if ($event.target.composing) {
              return
            }
            _vm.point_reward = $event.target.value
          },
        },
      }),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("label", { staticClass: "form-control-label" }, [
      _c("h4", [_vm._v("Point Reward")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }